import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";
import { EvidenceNNHandler } from "./EvidenceNNHandler";
import { GPONHandler } from "./GPONHandler";
import { OPMHandler } from "./OPMHandler";
import { PoleDBHandler } from "./PoleDBHandler";
import { HPTARHandler } from "../hptar-section/HPTARHandler";

export function DataCreationSection() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }
  return (
    <>
      <HPTARHandler id={id} hasRequiredAsterisk />
      <OPMHandler id={id} hasRequiredAsterisk />
      <EvidenceNNHandler id={id} hasRequiredAsterisk />
      <PoleDBHandler id={id} hasRequiredAsterisk />
      <GPONHandler id={id} hasRequiredAsterisk />
    </>
  );
}
